import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { akEditorFullPageNarrowBreakout } from '@atlaskit/editor-shared-styles';
import { boxShadowSelectionStyles, hideNativeBrowserTextSelectionStyles } from './selectionStyles';
export var DATASOURCE_INNER_CONTAINER_CLASSNAME = 'datasourceView-content-inner-wrap';
export var FLOATING_TOOLBAR_LINKPICKER_CLASSNAME = 'card-floating-toolbar--link-picker';
export var SmartCardSharedCssClassName = {
  INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
  BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
  EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
  DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
  LOADER_WRAPPER: 'loader-wrapper'
};

// Move this into `smartCardStyles` below when cleaning up editor_controls_patch_15
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var editorControlsSmartCardStyles = css(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.INLINE_CARD_CONTAINER), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-inlinecard-button-overlay="icon-wrapper-line-height"] span': {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0
  }
}));

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var smartCardDiffStyles = css(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.EMBED_CARD_CONTAINER), _defineProperty({}, "&[data-testid=\"show-diff-changed-decoration-node\"] .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div::after"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
  boxShadow: "0 0 0 1px var(--diff-decoration-marker-color)",
  borderColor: 'transparent'
})));

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var showDiffDeletedNodeStyles = css(_defineProperty(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.EMBED_CARD_CONTAINER), _defineProperty({}, "&.show-diff-deleted-node .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div::after"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-accent-gray, #7D818A)"),
  borderColor: 'transparent'
})), '.show-diff-deleted-node .media-card-wrapper', {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '& > div': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: "0 0 0 1px ".concat("var(--ds-border-accent-gray, #7D818A)"),
    borderRadius: "calc(".concat("var(--ds-radius-xsmall, 2px)", " + 1px)"),
    opacity: 0.6
  }
}));

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var smartCardStyles = css(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.INLINE_CARD_CONTAINER), _defineProperty(_defineProperty(_defineProperty({
  maxWidth: 'calc(100% - 20px)',
  verticalAlign: 'top',
  wordBreak: 'break-all',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.card-with-comment': {
    background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    borderBottom: "2px solid ".concat("var(--ds-border-accent-yellow, #B38600)"),
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.card': _defineProperty({
    paddingLeft: "var(--ds-space-025, 2px)",
    paddingRight: "var(--ds-space-025, 2px)",
    paddingTop: "var(--ds-space-100, 0.5em)",
    paddingBottom: "var(--ds-space-100, 0.5em)",
    marginBottom: "var(--ds-space-negative-100, -0.5em)"
  }, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a:focus"), [
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
  boxShadowSelectionStyles,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
  hideNativeBrowserTextSelectionStyles])
}, "&.ak-editor-selected-node .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a"), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles]), ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a"), {
  // EDM-1717: box-shadow Safari fix start
  zIndex: 1,
  position: 'relative'
}), '&.danger', _defineProperty({}, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a"), {
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)"),
  // EDM-1717: box-shadow Safari fix start
  zIndex: 2
  // EDM-1717: box-shadow Safari fix end
}))), ".".concat(SmartCardSharedCssClassName.BLOCK_CARD_CONTAINER), _defineProperty(_defineProperty({
  display: 'block',
  margin: '0.75rem 0 0',
  maxWidth: "".concat(8 * 95, "px")
}, "&.ak-editor-selected-node .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles, {
  borderRadius: "var(--ds-radius-large, 8px)"
}]), '&.danger', _defineProperty({}, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)", " !important")
}))), ".".concat(SmartCardSharedCssClassName.DATASOURCE_CONTAINER, ".").concat(SmartCardSharedCssClassName.BLOCK_CARD_CONTAINER), _defineProperty(_defineProperty(_defineProperty({
  maxWidth: '100%',
  display: 'flex',
  justifyContent: 'center'
}, ".".concat(DATASOURCE_INNER_CONTAINER_CLASSNAME), {
  cursor: 'pointer',
  backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
  borderRadius: "var(--ds-radius-large, 8px)",
  border: "1px solid ".concat("var(--ds-border, #0B120E24)"),
  overflow: 'hidden'
}), '&.ak-editor-selected-node', _defineProperty({}, ".".concat(DATASOURCE_INNER_CONTAINER_CLASSNAME), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles, {
  'input::selection': {
    backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
  },
  'input::-moz-selection': {
    backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
  }
}])), '&.danger', _defineProperty({}, ".".concat(DATASOURCE_INNER_CONTAINER_CLASSNAME), {
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)")
}))), ".".concat(SmartCardSharedCssClassName.EMBED_CARD_CONTAINER), _defineProperty(_defineProperty(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"), {
  cursor: 'pointer',
  '&::after': {
    transition: 'box-shadow 0s'
  }
}), "&.ak-editor-selected-node .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div::after"), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles]), '&.danger', {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.media-card-frame::after': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)", " !important"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    background: "var(--ds-background-danger, #FFECEB)".concat(" !important")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
    background: "var(--ds-border-danger, #E2483D)"
  }
})), ".".concat(FLOATING_TOOLBAR_LINKPICKER_CLASSNAME), {
  padding: 0
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var smartCardStylesWithSearchMatch = css(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.INLINE_CARD_CONTAINER), _defineProperty(_defineProperty(_defineProperty(_defineProperty({
  maxWidth: 'calc(100% - 20px)',
  verticalAlign: 'top',
  wordBreak: 'break-all',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.card-with-comment': {
    background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    borderBottom: "2px solid ".concat("var(--ds-border-accent-yellow, #B38600)"),
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.card': _defineProperty({
    paddingLeft: "var(--ds-space-025, 2px)",
    paddingRight: "var(--ds-space-025, 2px)",
    paddingTop: "var(--ds-space-100, 0.5em)",
    paddingBottom: "var(--ds-space-100, 0.5em)",
    marginBottom: "var(--ds-space-negative-100, -0.5em)"
  }, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a:focus"), [
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
  boxShadowSelectionStyles,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
  hideNativeBrowserTextSelectionStyles])
}, "&.ak-editor-selected-node .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a"), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles]), "&.ak-editor-selected-node:not(.search-match-block) .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a"),
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
[
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles]), ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a"), {
  // EDM-1717: box-shadow Safari fix start
  zIndex: 1,
  position: 'relative'
}), '&.danger', _defineProperty({}, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a"), {
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)"),
  // EDM-1717: box-shadow Safari fix start
  zIndex: 2
  // EDM-1717: box-shadow Safari fix end
}))), ".".concat(SmartCardSharedCssClassName.BLOCK_CARD_CONTAINER), _defineProperty(_defineProperty({
  display: 'block',
  margin: '0.75rem 0 0',
  maxWidth: "".concat(8 * 95, "px")
}, "&.ak-editor-selected-node .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles, {
  borderRadius: "var(--ds-radius-large, 8px)"
}]), '&.danger', _defineProperty({}, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)", " !important")
}))), ".".concat(SmartCardSharedCssClassName.DATASOURCE_CONTAINER, ".").concat(SmartCardSharedCssClassName.BLOCK_CARD_CONTAINER), _defineProperty(_defineProperty(_defineProperty({
  maxWidth: '100%',
  display: 'flex',
  justifyContent: 'center'
}, ".".concat(DATASOURCE_INNER_CONTAINER_CLASSNAME), {
  cursor: 'pointer',
  backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
  borderRadius: "var(--ds-radius-large, 8px)",
  border: "1px solid ".concat("var(--ds-border, #0B120E24)"),
  overflow: 'hidden'
}), '&.ak-editor-selected-node', _defineProperty({}, ".".concat(DATASOURCE_INNER_CONTAINER_CLASSNAME), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles, {
  'input::selection': {
    backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
  },
  'input::-moz-selection': {
    backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
  }
}])), '&.danger', _defineProperty({}, ".".concat(DATASOURCE_INNER_CONTAINER_CLASSNAME), {
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)")
}))), ".".concat(SmartCardSharedCssClassName.EMBED_CARD_CONTAINER), _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"), {
  cursor: 'pointer',
  '&::after': {
    transition: 'box-shadow 0s'
  }
}), "&.ak-editor-selected-node .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div::after"), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles]), "&.ak-editor-selected-node:not(.search-match-block) .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div::after"),
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
[
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles]), '&.danger', {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.media-card-frame::after': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)", " !important"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    background: "var(--ds-background-danger, #FFECEB)".concat(" !important")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
    background: "var(--ds-border-danger, #E2483D)"
  }
})), ".".concat(FLOATING_TOOLBAR_LINKPICKER_CLASSNAME), {
  padding: 0
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var smartCardStylesWithSearchMatchAndBlockMenuDangerStyles = css(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.INLINE_CARD_CONTAINER), _defineProperty(_defineProperty(_defineProperty(_defineProperty({
  maxWidth: 'calc(100% - 20px)',
  verticalAlign: 'top',
  wordBreak: 'break-all',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.card-with-comment': {
    background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    borderBottom: "2px solid ".concat("var(--ds-border-accent-yellow, #B38600)"),
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.card': _defineProperty({
    paddingLeft: "var(--ds-space-025, 2px)",
    paddingRight: "var(--ds-space-025, 2px)",
    paddingTop: "var(--ds-space-100, 0.5em)",
    paddingBottom: "var(--ds-space-100, 0.5em)",
    marginBottom: "var(--ds-space-negative-100, -0.5em)"
  }, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a:focus"), [
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
  boxShadowSelectionStyles,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
  hideNativeBrowserTextSelectionStyles])
}, "&.ak-editor-selected-node .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a"), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles]), "&.ak-editor-selected-node:not(.search-match-block):not(.danger) .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a"),
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
[
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles]), ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a"), {
  // EDM-1717: box-shadow Safari fix start
  zIndex: 1,
  position: 'relative'
}), '&.danger', _defineProperty({}, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > a"), {
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)"),
  // EDM-1717: box-shadow Safari fix start
  zIndex: 2
  // EDM-1717: box-shadow Safari fix end
}))), ".".concat(SmartCardSharedCssClassName.BLOCK_CARD_CONTAINER), _defineProperty(_defineProperty({
  display: 'block',
  margin: '0.75rem 0 0',
  maxWidth: "".concat(8 * 95, "px")
}, "&.ak-editor-selected-node .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles, {
  borderRadius: "var(--ds-radius-large, 8px)"
}]), '&.danger', _defineProperty({}, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)", " !important")
}))), ".".concat(SmartCardSharedCssClassName.DATASOURCE_CONTAINER, ".").concat(SmartCardSharedCssClassName.BLOCK_CARD_CONTAINER), _defineProperty(_defineProperty(_defineProperty({
  maxWidth: '100%',
  display: 'flex',
  justifyContent: 'center'
}, ".".concat(DATASOURCE_INNER_CONTAINER_CLASSNAME), {
  cursor: 'pointer',
  backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
  borderRadius: "var(--ds-radius-large, 8px)",
  border: "1px solid ".concat("var(--ds-border, #0B120E24)"),
  overflow: 'hidden'
}), '&.ak-editor-selected-node', _defineProperty({}, ".".concat(DATASOURCE_INNER_CONTAINER_CLASSNAME), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles, {
  'input::selection': {
    backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
  },
  'input::-moz-selection': {
    backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
  }
}])), '&.danger', _defineProperty({}, ".".concat(DATASOURCE_INNER_CONTAINER_CLASSNAME), {
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)")
}))), ".".concat(SmartCardSharedCssClassName.EMBED_CARD_CONTAINER), _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"), {
  cursor: 'pointer',
  '&::after': {
    transition: 'box-shadow 0s'
  }
}), "&.ak-editor-selected-node .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div::after"), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles]), "&.ak-editor-selected-node:not(.search-match-block) .".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div::after"),
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
[
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles]), '&.danger', {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.media-card-frame::after': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)", " !important"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    background: "var(--ds-background-danger, #FFECEB)".concat(" !important")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
    background: "var(--ds-border-danger, #E2483D)"
  }
})), ".".concat(FLOATING_TOOLBAR_LINKPICKER_CLASSNAME), {
  padding: 0
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var smartCardStylesWithSearchMatchAndPreviewPanelResponsiveness = css(_defineProperty({}, "@container editor-area (max-width: ".concat(akEditorFullPageNarrowBreakout, "px)"), _defineProperty(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.EMBED_CARD_CONTAINER), {
  marginTop: "var(--ds-space-150, 0.75rem)"
}), ".".concat(SmartCardSharedCssClassName.EMBED_CARD_CONTAINER, ".ak-editor-selected-node .").concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"),
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
[
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles, {
  borderRadius: "var(--ds-radius-large, 8px)"
}])));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var smartLinksInLivePagesStyles = css(_defineProperty(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.BLOCK_CARD_CONTAINER), _defineProperty({}, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"), {
  cursor: 'pointer',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  a: {
    cursor: 'auto'
  }
})), ".".concat(SmartCardSharedCssClassName.EMBED_CARD_CONTAINER), _defineProperty({}, ".".concat(SmartCardSharedCssClassName.LOADER_WRAPPER, " > div"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  a: {
    cursor: 'auto'
  }
})));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var linkingVisualRefreshV1Styles = css(_defineProperty({}, ".".concat(SmartCardSharedCssClassName.BLOCK_CARD_CONTAINER, ":not(.").concat(SmartCardSharedCssClassName.DATASOURCE_CONTAINER, ")"), {
  // EDM-11991: Fix list plugin adding padding to ADS AvatarGroup
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  'ul, ol': {
    paddingLeft: 'inherit'
  }
}));